// @ts-strict-ignore
import { jwtDecode, JwtPayload } from "jwt-decode";

import { browserLogs } from "merchant-portal-frontend/src/logger";

export interface BreadToken {
	accessToken: string;
	scopes: string[];
	claims: BreadJWT;
}

export interface BreadJWT extends JwtPayload {
	scp?: string[];
	cid?: string;
	uid?: string;
	tenantID?: string;
	merchantID?: string;
	sourceEntityIDs?: string[];
	sub?: string;
}

export const decodeBreadToken = (token: string): BreadToken | null => {
	if (!token) {
		return null;
	}

	try {
		const jwt = jwtDecode<BreadJWT>(token);
		return {
			accessToken: token,
			scopes: jwt.scp || [],
			claims: jwt,
		};
	} catch (error) {
		browserLogs.logger.error({ message: "failed to decode bread token", context: error });
		return null;
	}
};
